import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} ShipFromAddress
 * @property {string} id
 * @property {string} name
 * @property {string} phone
 * @property {string} address_line1
 * @property {string} company_name
 * @property {string} city_locality
 * @property {string} state_province
 * @property {string} postal_code
 * @property {string} country_code
 * @property {string} address_residential_indicator
 * @property {string} email
 * @property {number} agency_id
 */

/**
 * @typedef {Object} ShipFromAddressesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, ShipFromAddress>} data
 */

export const SHIP_FROM_ADDRESSES_ACTIONS = {
  SET_SHIP_FROM_ADDRESSES: 'SET_SHIP_FROM_ADDRESSES',
  SET_SHIP_FROM_ADDRESS: 'SET_SHIP_FROM_ADDRESS',
  SET_STATUS: 'SET_SHIP_FROM_ADDRESSES_STATUS',
  SET_ERRORS: 'SET_SHIP_FROM_ADDRESSES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_SHIP_FROM_ADDRESSES_ERRORS'
}

export const initialShipFromAddressesState = {
  status: 'idle',
  errors: [],
  data: {}
}

export const shipFromAddressesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      phone: PropTypes.string,
      address_line1: PropTypes.string,
      company_name: PropTypes.string,
      city_locality: PropTypes.string,
      state_province: PropTypes.string,
      postal_code: PropTypes.string,
      country_code: PropTypes.string,
      address_residential_indicator: PropTypes.string,
      email: PropTypes.string,
      agency_id: PropTypes.number
    })
  )
}
